import { render, staticRenderFns } from "./document-number-setting.vue?vue&type=template&id=950e6116&scoped=true&"
import script from "./document-number-setting.vue?vue&type=script&lang=ts&"
export * from "./document-number-setting.vue?vue&type=script&lang=ts&"
import style0 from "./document-number-setting.vue?vue&type=style&index=0&id=950e6116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950e6116",
  null
  
)

export default component.exports